import BaseModel from "./base/baseModel";

export default class EnsaioFichaTecnicaResultadoModel extends BaseModel {
    id?: number = null;
    ensaioFichaTecnicaId?: number;
    produtoLoteId?: number;
    resultado = "";
}
